import React, { useState, useEffect } from 'react';
import OtherAssetsModal from './OtherAssetsModal';

export default function OtherAssetsSection({ caseId, onSave,onChange,exemptions, scope }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;
  const TOKEN = localStorage.getItem('accessToken');

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(
          `${API_URL}/case/${caseId}/other-properties/`,
          { headers: { Authorization: `Bearer ${TOKEN}` } }
        );
        if (!res.ok) throw new Error('Network response was not ok');
        setItems(await res.json());
      } catch (e) {
        console.error('Failed to fetch other properties', e);
        setError(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [caseId]);

  const openAdd = () => {
    setEditingItem(null);
    setModalOpen(true);
  };

  const openEdit = (item) => {
    setEditingItem(item);
    setModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this item?')) return;
    try {
      const res = await fetch(
        `${API_URL}/case/${caseId}/other-properties/${id}/delete/`,
        { method: 'DELETE', headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (!res.ok) throw new Error();
      setItems(prev => prev.filter(i => i.id !== id));
    } catch {
      alert('Could not delete item.');
    }
  };

  const handleSave = (saved) => {
    // Compute new list based on current items prop
    const exists = items.find(i => i.id === saved.id);
    const updated = exists
      ? items.map(i => (i.id === saved.id ? saved : i))
      : [...items, saved];
    onChange(updated);
    onSave(updated);
    setModalOpen(false);
  };

  return (
    <section className="space-y-8 mt-12">
      <header
        onClick={() => {}}
        className="sticky top-0 z-10 bg-gray-100 w-full p-4 rounded-md flex items-center justify-between"
      >
        <h2 className="text-2xl font-semibold">Other Property</h2>
        <button
          onClick={openAdd}
          className="px-4 py-1 bg-blue-600 text-white rounded"
        >
          Add Other Property
        </button>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(item => (
          <div key={item.id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow flex flex-col">
            <h3 className="text-lg font-semibold mb-2">Other Property</h3>
            <ul className="space-y-1 text-sm text-gray-700 mb-4">
              <li><strong>Description:</strong> {item.description}</li>
              <li><strong>Amount:</strong> ${parseFloat(item.amount).toFixed(2)}</li>
              <li><strong>Exemption Code:</strong> {item.exemption_code || '–'}</li>
              <li><strong>Exemption Amt:</strong> ${item.exemption_amount != null ? parseFloat(item.exemption_amount).toFixed(2) : '0.00'}</li>
            </ul>
            <div className="mt-auto flex space-x-2">
              <button onClick={() => openEdit(item)} className="px-3 py-1 bg-yellow-500 text-white rounded">Edit</button>
              <button onClick={() => handleDelete(item.id)} className="px-3 py-1 bg-red-600 text-white rounded">Delete</button>
            </div>
          </div>
        ))}
      </div>
      <OtherAssetsModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        caseId={caseId}
        item={editingItem}
        onSave={handleSave}
        exemptions={exemptions}
        scope={scope}
      />
    </section>
  );
}
